function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#assignment2_svg__clip0_486_1415)"
}, React.createElement("path", {
  d: "M0 0h16v16H0V0z",
  fill: "#4FB9EF"
}), React.createElement("path", {
  d: "M4.667 10h4.666v1.333H4.667V10zm0-2.667h6.666v1.334H4.667V7.333zm0-2.666h6.666V6H4.667V4.667zm8-2.667H9.88A2.007 2.007 0 008 .667c-.867 0-1.6.56-1.88 1.333H3.333a1.339 1.339 0 00-1.227.82A1.284 1.284 0 002 3.333v9.334c0 .18.04.36.107.52a1.338 1.338 0 00.96.793c.086.013.173.02.266.02h9.334C13.4 14 14 13.4 14 12.667V3.333C14 2.6 13.4 2 12.667 2zM8 1.833c.273 0 .5.227.5.5 0 .274-.227.5-.5.5a.504.504 0 01-.5-.5c0-.273.227-.5.5-.5zm4.667 10.834H3.333V3.333h9.334v9.334z",
  fill: "#fff"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "assignment2_svg__clip0_486_1415"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

var SvgAssignment2 = function SvgAssignment2(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cg id='line/Assignment' clip-path='url(%23clip0_486_1415)'%3E %3Cpath id='Vector' d='M0 0H16V16H0V0Z' fill='%234FB9EF'/%3E %3Cpath id='Vector_2' d='M4.66667 10H9.33333V11.3334H4.66667V10ZM4.66667 7.33335H11.3333V8.66669H4.66667V7.33335ZM4.66667 4.66669H11.3333V6.00002H4.66667V4.66669ZM12.6667 2.00002H9.88C9.6 1.22669 8.86667 0.666687 8 0.666687C7.13333 0.666687 6.4 1.22669 6.12 2.00002H3.33333C3.24 2.00002 3.15333 2.00669 3.06667 2.02669C2.80667 2.08002 2.57333 2.21335 2.39333 2.39335C2.27333 2.51335 2.17333 2.66002 2.10667 2.82002C2.04 2.97335 2 3.14669 2 3.33335V12.6667C2 12.8467 2.04 13.0267 2.10667 13.1867C2.17333 13.3467 2.27333 13.4867 2.39333 13.6134C2.57333 13.7934 2.80667 13.9267 3.06667 13.98C3.15333 13.9934 3.24 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33335C14 2.60002 13.4 2.00002 12.6667 2.00002ZM8 1.83335C8.27333 1.83335 8.5 2.06002 8.5 2.33335C8.5 2.60669 8.27333 2.83335 8 2.83335C7.72667 2.83335 7.5 2.60669 7.5 2.33335C7.5 2.06002 7.72667 1.83335 8 1.83335ZM12.6667 12.6667H3.33333V3.33335H12.6667V12.6667Z' fill='white'/%3E %3C/g%3E %3Cdefs%3E %3CclipPath id='clip0_486_1415'%3E %3Crect width='16' height='16' fill='white'/%3E %3C/clipPath%3E %3C/defs%3E %3C/svg%3E";
export { SvgAssignment2 as ReactComponent };